import request from '../../utils/request';

/** 查询已归档的评估报告清单（新的在前；不读报告本体，只带结论与总覆盖率） */
export function fetchEvaluations() {
  return request.get('/blissrose/platform/evaluations');
}

/** 查询评估清单：执行器记录 ∪ 已归档报告（进行中与已结束都在列，新的在前） */
export function fetchEvalRuns() {
  return request.get('/blissrose/training/evaluations');
}

/** 查询一份评估报告的详情（含结论与训练来源）；training_source 查不到为 null */
export function fetchEvaluation(evalId) {
  return request.get(`/blissrose/platform/evaluations/${encodeURIComponent(evalId)}`);
}

/** 删除一份已归档评估报告的全部 MinIO 对象（不可恢复） */
export function deleteEvaluation(evalId) {
  return request.delete(`/blissrose/platform/evaluations/${encodeURIComponent(evalId)}`);
}

/** 发起一次评估：预校验在训练机，拒绝原因原样透出；split 必选无默认 */
export function dispatchEval(body) {
  return request.post('/blissrose/training/evaluations', body);
}

/** 查询可被评估的模型（含从 run 导入的产物）；source 标出来源 */
export function fetchEvalModels() {
  return request.get('/blissrose/training/evaluations/models');
}

/** 报告树对象的 URL（样例图直接用作 <img> src；浏览器直连，同站 cookie 鉴权） */
export function evaluationObjectUrl(evalId, relPath) {
  return `/api/blissrose/platform/evaluations/${encodeURIComponent(evalId)}/object`
    + `?path=${encodeURIComponent(relPath)}`;
}

/** 整份报告的打包下载直链（zip；浏览器直连，同站 cookie 鉴权） */
export function evaluationArchiveUrl(evalId) {
  return `/api/blissrose/platform/evaluations/${encodeURIComponent(evalId)}/archive`;
}
